__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "App";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("aem-vue-editable-components", "0.0.32", () => (() => (__webpack_require__(97287))), 1);
			register("axios-mock-adapter", "1.20.0", () => (() => (__webpack_require__(41270))), 1);
			register("axios", "0.27.2", () => (() => (__webpack_require__(14206))), 1);
			register("bootstrap-vue", "2.23.0-BCBSSC.1", () => (() => (__webpack_require__(66317))), 1);
			register("intersection-observer", "0.12.0", () => (() => (__webpack_require__(17827))), 1);
			register("pinia", "2.0.36", () => (() => (__webpack_require__(48272))), 1);
			register("uuid", "9.0.0", () => (() => (__webpack_require__(42109))), 1);
			register("vue-class-component", "8.0.0-rc.1", () => (() => (__webpack_require__(25625))), 1);
			register("vue", "3.2.47", () => (() => (__webpack_require__(96164))), 1);
			initExternal(23978);
			initExternal(69767);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};